import React, {useContext, useEffect} from 'react';
import farmerContext from "../../context/farmer/farmerContext";
import EquipmentService from "../farmer/equipment_service/EquipmentService";
import {useAlert} from "react-alert";

const FarmerDashboard = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const FarmerContext = useContext(farmerContext);
    const alert = useAlert()
    const {farmer, clearAlert, getUserBank, getFarmerStats} = FarmerContext;
    const {stats} = farmer

    useEffect(() => {
        if (stats.length === 0) {
            getUserBank()
            getFarmerStats()
        }
        if (farmer.message.msg !== "") {
            alert.show(
                farmer.message.msg, farmer.message.msg_options
            )
            clearAlert()

        }
    }, [farmer.message.msg])

    return (
        <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Dashboard</h3>
                <h4>Hello {userInfo.last_name}</h4>

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-12 col-lg-6 col-xl-3 mb-4">
                            <div className="card bg-color-1">
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <p className="text-white">Completed Services</p>
                                            <h4 className="text-white line-height-5">{stats.completed_services}</h4>
                                        </div>
                                        <div className="w-circle-icon rounded-circle border border-white">
                                            <i className="fa fa-pie-chart text-white"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-3 mb-4">
                            <div className="card  bg-color-2">
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <p className="text-white">Farms</p>
                                            <h4 className="text-white line-height-5">{stats.no_of_farms}</h4>
                                        </div>
                                        <div className="w-circle-icon rounded-circle border border-white">
                                            <i className="fa fa-pie-chart text-white"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-3 mb-4">
                            <div className="card bg-color-3">
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <p className="text-white">Ongoing Services</p>
                                            <h4 className="text-white line-height-5">{stats.ongoing_services}</h4>
                                        </div>
                                        <div className="w-circle-icon rounded-circle border border-white">
                                            <i className="fa fa-pie-chart text-white"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-3 mb-4">
                            <div className="card  bg-color-4">
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <p className="text-white">Wallet Balance</p>
                                            <h4 className="text-white line-height-5">₦0.00</h4>
                                        </div>
                                        <div className="w-circle-icon rounded-circle border border-white">
                                            <i className="fa fa-pie-chart text-white"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <EquipmentService/>

                </div>

            </div>
        </div>

    )
};


export default FarmerDashboard;